export default function RankingPosition({ ranking }: any) {

  return (
    <div className='mb-3 px-4'>
      <div className={`w-full flex items-center ${!ranking?.currentPosition ? 'justify-center' : 'justify-between'} py-1 px-5 rounded-full border border-solid position`}>
        {
          !ranking?.currentPosition
            ? (
              <>
                <p className='text medium text-center'>Tienes que jugar para ingresar en el ranking.</p>
              </>
            )
            : (
              <>
                <p className='text medium'>Estás en la posición <b>°{ranking?.currentPosition?.id ?? '-'}</b></p>
                <hr className='h-full border-l border-solid' />
                <p className='text big font-bold'>{ranking?.currentPosition?.points ?? '0'} {POINTS_NAME}</p>
              </>
            )
        }
      </div>
    </div>
  )
}